module.exports = __webpack_public_path__ + "static/media/Wecker-sound.46e4e21d.mp3";